import { gql } from '@apollo/client';

/**
 *  Object Parameters 
 {
  "searchAccomplishment": {
    "q": "null",
    "sortColumn": "",
    "sort": "",
    "page": 1,
    "perPage": 10
  }
}
 *  
 * 
 * */

export const ListAccomplishments = gql`
  query ListAccomplishments($search: SearchAccomplishmentInput!) {
    listAccomplishments(search: $search) {
      docs {
        _id
        title
        type
        quantity
        cover
        status
        reached
        disable
      }
      page
      limit
      totalDocs
      totalPages
    }
  }
`;
